import CustomInput from "@components/CustomInput/CustomInput";
import { Stack } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import "./index.scss";
const QuoteDetails = ({
  initialValues,
  numeroDevis,
  isUpdate,
  titleSection,
  register,
}) => {
  console.log("🚀 ~ register:", register);
  console.log("🚀 ~ initialValues:", initialValues);
  console.log("🚀 ~ register(numeroDevis):", register("numeroDevis"));
  const { t } = useTranslation();
  return (
    <Stack
      sx={{
        backgroundColor: "#f8fbff",
        padding: "1.5rem",
        borderRadius: "16px",
      }}>
      <p className="detail-title">
        {titleSection ? titleSection : t("invoice.details_title")}
      </p>
      <div className="">
        <CustomInput
          classname={"invoice-number quote_num"}
          label={t("quote.quote_num")}
          value={numeroDevis}
          type={"text"}
          isReadOnly={true}
          isDisabled={true}
          classNameDivInput={"input-num-devis"}
          register={register("numeroDevis")}
        />
      </div>
      <Stack
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexDirection: "row",
        }}>
        <div className="invoice-dates">
          <CustomInput
            classname={"date-input"}
            label={t("quote.startDate_label")}
            type={"date"}
            register={register("startDate")}
          />
          <CustomInput
            classname={"date-input"}
            label={t("quote.issueDate_label")}
            register={register("issueDate")}
            type={"date"}
          />
        </div>
        <div>

        </div>
      </Stack>
    </Stack>
  );
};

export default QuoteDetails;
